// extracted by mini-css-extract-plugin
export default {"blogsImage":"blogs_blogsImage__tfEXp","blogsHeading":"blogs_blogsHeading__LAEoT","blogsSpan":"blogs_blogsSpan__sKOQS","blogsQuestion":"blogs_blogsQuestion__p1rlG"};